module.exports = __webpack_public_path__ + "img/incomplete.c4173f1b.png";